import { DynamicContainer, FormSection } from '@hai/ui-react';
import { Formik } from 'formik';
import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { FormikTextfield } from 'src/js/component/base/form/formik-textfield';
import { StateButton } from 'src/js/component/base/state-button';
import { validateFormContext } from 'src/js/validator/validator';

import { ServicesViewModel, servicesValidationSchema } from './services-view-model';

export interface PassthroughFormValues {
  passthroughPort: number;
}

interface Props {
  services: ServicesViewModel;
  onSubmit?: (formValues: PassthroughFormValues) => Promise<any>;
}

export const PassthroughForm = (props: Props) => {
  const formRef = useRef(null);

  const { t } = useTranslation();

  return (
    <Formik
      initialValues={{
        passthroughPort: props.services.passthroughPort,
      }}
      validationSchema={() => servicesValidationSchema(t)}
      onSubmit={props.onSubmit}
      enableReinitialize={true}
      innerRef={formRef}
    >
      {(formikProps) => {
        return (
          <form className="hai-mb-6">
            <FormSection title={t('settings.services.section.passthrough.title')}>
              <DynamicContainer minColumns={3}>
                <FormikTextfield
                  title={t('settings.services.section.passthrough.port')}
                  name="passthroughPort"
                  type="number"
                  hint={t('settings.services.section.passthrough.portExplain')}
                  required
                />
                <div />
                <div className="d-flex">
                  <div className="ml-auto">
                    <StateButton
                      variant="primary"
                      onClick={() => validateFormContext(formikProps, t)}
                      disabled={!formikProps.dirty}
                    >
                      {t('general.apply')}
                    </StateButton>
                  </div>
                </div>
              </DynamicContainer>
            </FormSection>
          </form>
        );
      }}
    </Formik>
  );
};
